/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import cookies from 'react-cookies';
import iconPlay from '../../assets/icons/icon-start.svg';
import iconStop from '../../assets/icons/icon-stop.svg';
import { TableContract, BarLoading, MobileTable, Empty } from './styles';
import { TableContent } from '../../pages/Dashboard/index';
import { Loader } from '../Loader';
import api from '../../services/api';

const Table = ({
  columns,
  data,
  dataMobile,
  loading,
  barProgress,
}: TableContent) => {
  const history = useHistory();
  const [loadBarProgress, setLoadBarProgress] = useState<boolean>();
  const dataTable = data;
  const dataTableMobile = dataMobile;

  useEffect(() => {
    setLoadBarProgress(barProgress);
    localStorage.removeItem('proposalInfoClient');
  }, []);

  function statusText(status: string) {
    switch (status) {
      case 'AP':
        return 'Aprovada';
      case 'RE':
        return 'Rejeitada';
      case 'PE':
        return 'Pendente';
      case 'DI':
        return 'Finalizada';
      default:
        return 'Edição';
    }
  }

  function statusColor(status: string) {
    switch (status) {
      case 'AP':
        return '#0DB14B';
      case 'RE':
        return '#E01342';
      case 'PE':
        return '#FD6720';
      case 'DI':
        return '#747474';
      default:
        return '#e6b800';
    }
  }

  async function handleDetails(id: number, status: string) {
    if (status === 'ED' && cookies.load('external_tags').gps_recebedor) {
      setLoadBarProgress(true);
      try {
        const response = await api.get(
          `${
            process.env.REACT_APP_API_REQUEST_ENDPOINT
          }/v0/gps/merchants/${cookies.load(
            'external_stone_codes',
          )}/proposals/${id}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.load('external_token')}`,
            },
          },
        );
        if (response.status !== 200 && response.status !== 204) {
          alert(response.statusText);
        } else {
          localStorage.setItem(
            'proposalInfoClient',
            JSON.stringify(response.data),
          );
          history.push('/newcontract/review');
        }
      } catch (error) {
        alert(error);
      }
      history.push('/newcontract/review');
    } else if (
      status === 'PE' &&
      (cookies.load('external_tags').gps_originador ||
        (cookies.load('external_tags').gps_originador &&
          cookies.load('external_tags').gps_recebedor))
    ) {
      history.push(`/accept/${id}`);
    } else if (status === 'PE' && cookies.load('external_tags').gps_recebedor) {
      history.push(`/details/${id}`);
    } else {
      history.push(`/details/${id}`);
    }
  }
  if (loading) {
    return <Loader />;
  }
  if (dataTable.length > 0) {
    return (
      <>
        <BarLoading
          style={{
            height: 2,
            visibility: barProgress || loadBarProgress ? 'visible' : 'hidden',
          }}
        />
        <TableContract>
          <thead>
            <tr>
              {columns.map(column => (
                <th key={column.accessor}>{column.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataTable.map(row => {
              return (
                <tr
                  key={row.id}
                  onClick={e => {
                    handleDetails(row.id, row.status);
                  }}
                >
                  <td className="middleTd">{`00000${row.id}`.slice(-5)}</td>
                  <td className="middleTd">
                    {cookies.load('external_tags').gps_recebedor
                      ? row.debtor.document
                      : row.creditor.document}
                  </td>
                  <td className="middleTd" id="percentTd">
                    {cookies.load('external_tags').gps_recebedor
                      ? row.debtor.fantasy_name
                      : row.creditor.fantasy_name}
                  </td>
                  <td>
                    {`${row.created_at.substring(
                      8,
                      10,
                    )} / ${row.created_at.substring(
                      5,
                      7,
                    )}/${row.created_at.substring(0, 4)}`}
                  </td>
                  <td>
                    {`${row.due_date.substring(8, 10)}/${row.due_date.substring(
                      5,
                      7,
                    )}/${row.due_date.substring(0, 4)}`}
                  </td>
                  <td className="middleTd">
                    {`${parseFloat(
                      row.percentage_value ? row.percentage_value : '0',
                    ).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                    })} %`}
                  </td>
                  <td className="rightTd">
                    {parseFloat(
                      row.total_value ? row.total_value : '0',
                    ).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </td>
                  <td
                    className="middleTd"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: 10,
                        marginRight: 5,
                        background: statusColor(row.status),
                      }}
                    />
                    {statusText(row.status)}
                  </td>
                </tr>
              );
            })}
          </tbody>
          {dataTableMobile.map(row => (
            <MobileTable
              key={row.id}
              onClick={e => {
                handleDetails(row.id, row.status);
              }}
            >
              <div className="mobile-two-column">
                <span
                  style={{
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: 500,
                    color: 'var(--color-primary-light)',
                  }}
                >
                  {`Proposta ${`00000${row.id}`.slice(-5)}`}
                </span>
                <div
                  style={{
                    backgroundColor: statusColor(row.status),
                    padding: '5px 10px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '10px',
                    borderRadius: 10,
                  }}
                >
                  {statusText(row.status)}
                </div>
              </div>
              <div className="columns">
                <div className="mobile-column" style={{ textAlign: 'left' }}>
                  <span className="title-name">
                    {cookies.load('external_tags').gps_recebedor
                      ? row.debtor.fantasy_name
                      : row.creditor.fantasy_name}
                  </span>
                  <span className="description-text">
                    {cookies.load('external_tags').gps_recebedor
                      ? row.debtor.document
                      : row.creditor.document}
                  </span>
                </div>
                <div className="mobile-column">
                  <span className="description-text">
                    <img
                      src={iconPlay}
                      alt="Start"
                      style={{
                        marginRight: 5,
                        color: 'var(--color-primary-light)',
                      }}
                    />
                    {`${row.created_at.substring(
                      8,
                      10,
                    )}/${row.created_at.substring(
                      5,
                      7,
                    )}/${row.created_at.substring(0, 4)}`}
                  </span>
                  <span className="description-text">
                    <img
                      src={iconStop}
                      alt="Stop"
                      style={{
                        marginRight: 5,
                        color: 'var(--color-primary-light)',
                      }}
                    />
                    {`${row.due_date.substring(8, 10)}/${row.due_date.substring(
                      5,
                      7,
                    )}/${row.due_date.substring(0, 4)}`}
                  </span>
                </div>
                <div className="mobile-column" style={{ textAlign: 'right' }}>
                  <span className="description-text">
                    {`${parseFloat(
                      row.percentage_value ? row.percentage_value : '0',
                    ).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                    })} %`}
                  </span>
                  <span className="description-text">
                    {parseFloat(
                      row.total_value ? row.total_value : '0',
                    ).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </span>
                </div>
              </div>
            </MobileTable>
          ))}
        </TableContract>
      </>
    );
  }
  return (
    <Empty>
      Não há nada para mostrar!
      <br />
      Suas propostas, quando existirem, serão listadas aqui.
    </Empty>
  );
};

export default Table;
